import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { SiteConfigContext } from '@jelly/components'

const FooterContainer = styled.footer`
	align-items: center;
	display: flex;
	background: ${({ theme }) => theme.palette.primary.main};
	height: 150px;
	justify-content: center;
	width: 100%;
	* {
		max-width: 150px;
	}
`

/**
 * Footer that just consists of the site Logo
 */
export function Footer() {
	const {
		siteComponents: { SiteLogo },
	} = useContext(SiteConfigContext)

	return (
		<FooterContainer id="footer">
			<SiteLogo color="#FFFFFF" />
		</FooterContainer>
	)
}
